export default __webpack_public_path__ + "static/media/helper-required.607ff357.png";